/*
 * FÄRGFÖRSLAG v2 (lokalt test, ej live), mönster 5: överstruket ordinarie pris inne i köpknappen.
 * Körs bara när <html> har klassen evfv2 (sätts enbart på localhost i theme.liquid).
 */
(function () {
  if (!document.documentElement.classList.contains('evfv2')) return;

  function compareFor(box) {
    // Egen nivåväljare: bara den valda nivåns jämförpris (reservhuvudena har inget)
    var opt = box.querySelector('[data-pdp-opt].is-active');
    if (opt) return (opt.dataset.compare || '').trim();
    var el = box.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-full-price');
    if (el) return el.textContent.trim();
    // Prisradens jämförpris bara om det syns (dolt = reservvärde, inte produktens pris)
    el = box.querySelector('.pdp-price__was');
    return el && el.offsetParent !== null ? el.textContent.trim() : '';
  }

  function update() {
    document.querySelectorAll('.pdp-cta--block, .pdp-sticky__btn').forEach(function (btn) {
      var price = btn.querySelector('[data-pdp-cta-price]');
      var box = btn.closest('.shopify-section') || document;
      if (!price) {
        var main = document.querySelector('.pdp-cta--block [data-pdp-cta-price]');
        if (!main || btn.querySelector('.evfv2-sticky-price')) return;
      }
      var was = compareFor(box.querySelector('.pdp-opt, .kaching-bundles, .pdp-price') ? box : document);
      var now = price ? price.textContent.trim() : '';
      // Tankstreck bort ur knapptexten (skrivregel), ersätts med punkt
      btn.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && n.textContent.indexOf('—') > -1) n.textContent = n.textContent.replace(/\s*—\s*/, ' · ');
      });
      var s = btn.querySelector('.evfv2-was');
      if (!price) return;
      if (!was || was === now) { if (s) s.remove(); return; }
      if (!s) { s = document.createElement('s'); s.className = 'evfv2-was'; price.parentNode.insertBefore(s, price); }
      if (s.textContent !== was) s.textContent = was;
    });
  }

  var t = null;
  function soon() { if (t) return; t = setTimeout(function () { t = null; update(); }, 60); }
  function start() {
    update();
    new MutationObserver(soon).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

// Siffror i "Klinikens teknik": rullande räkneverk (canvas variant B), startar när de syns
(function () {
  if (!document.documentElement.classList.contains('evfv2')) return;
  var css = '.evfv2-roll{display:inline-block;height:1em;overflow:hidden;line-height:1;vertical-align:top}' +
    '.evfv2-roll>span{display:flex;flex-direction:column;transform:translateY(0)}' +
    '.evfv2-roll>span>span{display:block;height:1em;line-height:1}' +
    '.evfv2-rolled .evfv2-roll>span{transition:transform 1.5s cubic-bezier(.16,1,.3,1)}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function build(el) {
    var txt = el.textContent.trim(); if (!txt || el.dataset.evRoll) return;
    el.dataset.evRoll = '1'; el.setAttribute('aria-label', txt); el.textContent = '';
    txt.split('').forEach(function (ch, i) {
      if (!/[0-9]/.test(ch)) { var s = document.createElement('span'); s.textContent = ch; s.setAttribute('aria-hidden', 'true'); el.appendChild(s); return; }
      var w = document.createElement('span'); w.className = 'evfv2-roll'; w.setAttribute('aria-hidden', 'true');
      var strip = document.createElement('span'); strip.dataset.d = ch; strip.style.transitionDelay = (i * 90) + 'ms';
      for (var n = 0; n < 10; n++) { var d = document.createElement('span'); d.textContent = n; strip.appendChild(d); }
      w.appendChild(strip); el.appendChild(w);
    });
  }
  function go(el) { el.classList.add('evfv2-rolled'); el.querySelectorAll('[data-d]').forEach(function (s) { s.style.transform = 'translateY(-' + s.dataset.d + 'em)'; }); }
  function init() {
    var els = document.querySelectorAll('.evx-brand__metrics .evx-num'); if (!els.length || reduce) return;
    els.forEach(build);
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { requestAnimationFrame(function () { go(e.target); }); io.unobserve(e.target); } }); }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
